/* eslint-disable */
import {BuyerCookieService} from '@nuskin/ns-account';
import CartServiceAdaptor from './ltocart/cartServiceAdaptor.js';
import {nuskin} from '@nuskin/ns-util';

/**
 *
 * LtoUtils
 *
 * @namespace LtoUtils
 */
let LtoUtils = function () {
    var publicMethods = {
        secureHost: "https://www.nuskin.com",
        cartCleared: false,

        /**
         * Clear cart
         * @memberof LtoUtils
         * @example
         * LtoUtils.clearCart()
         */
        clearCart: function () {
            if (!publicMethods.cartCleared) {
                CartServiceAdaptor.resetCart();
                // do clear cart ajax call
                if (nuskin.util.isEcom3()) {
                    $.ajax({
                        url: nuskin.util.shopAppUrl + "clear-session",
                        type: "GET"
                    });
                }
                publicMethods.cartCleared = true;
            }
        },

        /**
         * Clear Buyer Info from Cookie and Storage
         * @memberof LtoUtils
         * @example
         * LtoUtils.clearBuyer()
         */
        clearBuyer: function () {
            BuyerCookieService.resetBuyerCookie();
            nuskin.storage.setItem(nuskin.storage.metadata.BUYER_FORM, null);
            nuskin.storage.setItem(nuskin.storage.metadata.LTO_VERIFY, null);
        },

        /**
         * This is a function for the waiting room
         * @memberof LtoUtils
         * @example
         * LtoUtils.isProtectedPage()
         * @returns {boolean} isProtectedPage
         */
        isProtectedPage: function () {
            if (siteConfig.protectedPages) {
                for (let i = 0; i < siteConfig.protectedPages.length; i++) {
                    let pageName = window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1);
                    if (pageName.indexOf(siteConfig.protectedPages[i]) > -1) {
                        return true;
                    }
                }
            }
            return false;
        },

        /**
         * isBdActivated
         * @memberof LtoUtils
         * @example
         * LtoUtils.isBdActivated()
         * @returns {boolean} isBdActivated
         */
        isBdActivated: function () {
            let activated = false;
            if (siteConfig.wrbd) {
                let wrkey = nuskin.storage.getItem(nuskin.storage.metadata.WR_KEY);
                activated = siteConfig.wrbd && wrkey == siteConfig.bdpwd;
            }
            return activated;
        },

        /**
         * isWCMDisabled
         * @memberof LtoUtils
         * @example
         * LtoUtils.isWCMDisabled()
         * @returns {boolean} isWCMDisabled
         */
        isWCMDisabled: function () {
            return (typeof(CQ) === 'undefined' || typeof(CQ.WCM) === 'undefined' || CQ.WCM.isPreviewMode());
        },

        /**
         * This is a function for the waiting room
         * @memberof LtoUtils
         * @example
         * LtoUtils.isWaitingRoomActive()
         * @returns {boolean} isWaitingRoomActive
         */
        isWaitingRoomActive: function () {
            return (publicMethods.isWCMDisabled() && !publicMethods.isBdActivated() && siteConfig.waitingRoom && publicMethods.isProtectedPage());
        },

        /**
         * If object is undefined return default value
         * @memberof LtoUtils
         * @example
         * LtoUtils.getValue(obj, defaultValue)
         * @returns {object} obj or default value
         */
        getValue: function (obj, defaultValue) {
            try {
                if (typeof eval(obj) !== "undefined") {
                    return eval(obj);
                }
                return defaultValue;
            } catch (e) {
                return defaultValue;
            }
        },

        /**
         * Get's site config
         * @memberof LtoUtils
         * @example
         * LtoUtils.getSiteConfig()
         * @returns {object} siteConfig
         */
        getSiteConfig: function () {
            let SITECONFIG = "siteConfig";
            return publicMethods.getValue(SITECONFIG, "{}");
        },

        /**
         * Get's cached script
         * @memberof LtoUtils
         * @example
         * LtoUtils.getCachedScript(url, callback)
         * @returns {callback}
         */
        getCachedScript: function (url, callback) {
            $.ajax({
                type: "GET",
                url: url,
                success: callback,
                dataType: "script",
                cache: true
            });
        }
    };

    return publicMethods;
}();

export default LtoUtils;
